import {React,useState,useEffect} from "react";
//import {isMobile} from 'react-device-detect';
import { useNavigate,Link } from "react-router-dom";
import moment from "moment";
import axiosInstance from "../../../utils/axiosInstance";
const RightSide = ({
  betObj,
  closeBetSlipParent,
  placeBetParent,
  betErrorMessageObj,
  clearBetSlipParent,
  matchOdds,
  relatedEvents,
  betList,
  unmatchedBetList,
  stakeList,
  showDesktopSlip,
  eventDetails,
  refreshBetListParent
}) => {
  let isMobile = false;
  let betSlipDisplayStatus = false;

  const [stakeValue, setStakeValue] = useState({ value: "" });
  const [profit, setProfitValue] = useState(0);
  const [liability, setLiabilityValue] = useState(0);
  const [betErrorMessage, setBetErrorMessage] = useState("");

  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);

  const [showProfitLossCalculation, setProfitLossCalculation] = useState(false);

  const [betListArray, setBetListArray] = useState("");
  const [unmatchedBetListArray, setUnmatchedBetListArray] = useState([]);
  const [deletingUnmatchedIds, setDeletingUnmatchedIds] = useState({});

  const [defaultAmount, setDefaultAmount] = useState("");

  const [tvStatus, setTvStatus] = useState(false);
  const [scoreStatus, setScoreStatus] = useState(false);

  let bpro = 0;
  let lib = 0;
  let stake1 = 100;
  let stake2 = 200;
  let stake3 = 500;
  let stake4 = 1000;

  let stake5 = 5000;
  let stake6 = 10000;
  let stake7 = 20000;
  let stake8 = 50000;

  if (betObj !== null && betObj !== "" && betObj.bet_type !== undefined) {
    if (isMobile === false) {
      betSlipDisplayStatus = true;
    }
  }

  if (!showDesktopSlip) {
    betSlipDisplayStatus = false;
  }

  if (
    stakeList !== undefined &&
    stakeList !== null &&
    stakeList !== "" &&
    stakeList.stake1 !== undefined &&
    stakeList.stake1 !== null
  ) {
    stake1 = stakeList.stake1;
    stake2 = stakeList.stake2;
    stake3 = stakeList.stake3;
    stake4 = stakeList.stake4;

    stake5 = stakeList.stake5;
    stake6 = stakeList.stake6;
    stake7 = stakeList.stake7;
    stake8 = stakeList.stake8;
  }

  function displayTime(evt_od) {
    let mongoTime = evt_od?.$date?.$numberLong;
    let eventDate = moment(Number(mongoTime)).local().format("hh:mm A");
    return eventDate;
  }

  //console.log("showDesktopSlip->", showDesktopSlip);
  useEffect(() => {
    if (betList !== undefined && betList !== null && betList.length > 0) {
      setBetListArray(betList);
    } else {
      setBetListArray([]);
    }
  }, [betList]);

  useEffect(() => {
    if (
      unmatchedBetList !== undefined &&
      unmatchedBetList !== null &&
      unmatchedBetList.length > 0
    ) {
      setUnmatchedBetListArray(
        unmatchedBetList.filter(
          (bet) =>
            Number(bet.isDeleted ?? 0) === 0 && Number(bet.isSettled ?? 0) === 0
        )
      );
    } else {
      setUnmatchedBetListArray([]);
    }
  }, [unmatchedBetList]);

  const deleteUnmatchedBet = async (betId) => {
    if (!betId || deletingUnmatchedIds[betId]) {
      return;
    }

    setDeletingUnmatchedIds((prev) => ({ ...prev, [betId]: true }));

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await axiosInstance.delete(
        "/markets/unmatched-bet/" + betId
      );

      if (response.data?.status) {
        setUnmatchedBetListArray((prev) =>
          prev.filter((bet) => String(bet._id) !== String(betId))
        );
        if (typeof refreshBetListParent === "function") {
          refreshBetListParent();
        }
      }
    } catch (error) {
      console.error("Error deleting unmatched bet:", error);
    } finally {
      setDeletingUnmatchedIds((prev) => {
        const next = { ...prev };
        delete next[betId];
        return next;
      });
    }
  };

  const showScoreBoard = () => {
    setTvStatus(false);
    setScoreStatus(true);
  };

  const showTv = () => {
    setTvStatus(true);
    setScoreStatus(false);
  };

  const getTypeAmount = (amount) => {
    amount = Number(amount);
    setDefaultAmount(amount);
  };

  useEffect(() => {
    if (defaultAmount > 0) {
      setProfitLoss();
    }
  }, [defaultAmount]);

  const closeBetSlip = () => {
    betSlipDisplayStatus = false;
    //setStakeValue({ value: "", type: "" });
    setLiabilityValue(0);
    setProfitValue(0);
    closeBetSlipParent();
    setDefaultAmount("");
    setBetErrorMessage("");
    setProfitLossCalculation(false);
  };

  const setStake = (value) => {
    if (defaultAmount > 0) {
      let newValue = Number(defaultAmount) + Number(value);
      setDefaultAmount(newValue);
    } else {
      setDefaultAmount(value);
    }

    /*if (stakeValue.value > 0) {
      let newValue = stakeValue.value + value;
      setStakeValue({ value: newValue });
    } else {
      setStakeValue({ value });
    }*/
  };

  const setProfitLoss = () => {
    if (betObj.market_type === "f" || betObj.market_type === "betfairfancy") {
      if (betObj.market_type === "betfairfancy") {
        betObj.price = 100;
      }

      if (betObj.bet_type === "l") {
        bpro = defaultAmount;
        lib = Math.round((betObj.price * defaultAmount) / 100);
        setLiabilityValue(lib);
        setProfitValue(bpro);
        setProfitLossCalculation(true);
      } else {
        bpro = defaultAmount;
        lib = Math.round((betObj.price * defaultAmount) / 100);
        setLiabilityValue(lib);
        setProfitValue(bpro);
        setProfitLossCalculation(true);
      }
    } else {
      if (betObj.bet_type === "b") {
        let liveRate = betObj.odds;
        if (liveRate > 0) {
          let liabilityNew = defaultAmount;
          setLiabilityValue(liabilityNew);

          let profitNew = Math.round(liveRate * liabilityNew - liabilityNew);
          setProfitValue(profitNew);
          setProfitLossCalculation(true);
        }
      } else {
        let liveRate = betObj.odds;
        if (liveRate > 0) {
          let profitNew = defaultAmount;
          setProfitValue(profitNew);

          let liabilityNew = Math.round(liveRate * profitNew - profitNew);
          setLiabilityValue(liabilityNew);
          setProfitLossCalculation(true);
        }
      }
    }
  };

  const clearStake = () => {
    //setStakeValue({ value: "", type: "" });
    setLiabilityValue(0);
    setProfitValue(0);
    setBetErrorMessage("");
    setProfitLossCalculation(false);
    clearBetSlipParent();
    setDefaultAmount("");
  };
  const setOddValue = (value) => {
    if (eventDetails.pending) {
      // Allow numbers with up to 2 decimal places
      if (/^\d*\.?\d{0,2}$/.test(value)) {
        betObj.odds = value;
      }
    }
  };

  const place_bet = () => {
    //const intervalId = setInterval(() => {
    if (defaultAmount > 0) {
      setBetErrorMessage("");
      setButtonShowLoaderShow(true);
      setBetButtonShow(false);
      placeBetParent(defaultAmount);
      //clearInterval(intervalId);
    }
    //}, 10000); // 1 second
  };
  useEffect(() => {
    if (betErrorMessageObj !== null && betErrorMessageObj !== undefined) {
      if (
        betErrorMessageObj.status !== null &&
        betErrorMessageObj.status !== undefined
      ) {
        if (betErrorMessageObj.status) {
          setBetErrorMessage("");
          closeBetSlip();
          setButtonShowLoaderShow(false);
          setBetButtonShow(true);
          betSlipDisplayStatus = false;
        } else {
          setButtonShowLoaderShow(false);
          setBetButtonShow(true);
          setBetErrorMessage(betErrorMessageObj.message);
        }
      }
    }
  }, [betErrorMessageObj]);

  const DateCheck = (date) => {
    date = new Date(date);
    //console.log("date->",date);
    const formattedDate = moment(date);
    const today = moment().startOf("day");
    const tomorrow = moment().add(1, "day").startOf("day");
    let label;
    if (formattedDate.isSame(today, "day")) {
      label = "Today";
    } else if (formattedDate.isSame(tomorrow, "day")) {
      label = "Tomorrow";
    } else {
      label = formattedDate.format("YYYY-MM-DD");
    }

    return label;
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  function displayTime(evt_od) {
    evt_od = new Date(evt_od);
    let mongoTime = evt_od;
    let eventDate = moment(Number(mongoTime)).local().format("hh:mm A");
    return eventDate;
  }

  const displayPrice = (value, betType) => {
    if (betType == "f") {
      return formatTruncate(value);
    } else if (betType == "bm") {
      return Number(value).toFixed(2);
    } else {
      return value;
    }
  };
  const showEventName = (event) => {
    let displayName = "";
    if (event.game_type == 4 || event.game_type == 5) {
      displayName =
        displayTime(event.evt_od) +
        " " +
        event.venue +
        " (" +
        event.countryCode +
        ")" +
        " " +
        event.matchSummaryText4;
    } else {
      displayName = event.evt_evt;
    }
    return displayName;
  };

    const getIframeUrl = (eventType, evt_id) => {
      let url = "";
      if (eventType == 1 || eventType == 2 || eventType == 3) {
        url = "https://e765432.diamondcricketid.com/dtv.php?id=" + evt_id;
      } else {
        url = "https://d3.ullu7.com/embed/" + evt_id;
      }

      return url;
    };

    return (
      <div
        className="right-content-wrapper"
        style={{ background: "var(--theme-bg-color)" }}
      >
        <style>{`
        @keyframes unmatchedDeleteSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
        <div className="tv-section-wrapper">
          <ul className="nav nav-tabs" role="tablist">
            <li
              className="nav-item"
              style={{
                width:
                  eventDetails.game_type == 4 || eventDetails.game_type == 5
                    ? "100%"
                    : "50%"
              }}
            >
              <a
                className="nav-link tvOpen "
                onClick={() => showTv()}
                data-toggle="tab"
                href="#tv-section-1"
                role="tab"
                style={{
                  borderRadius: "5px 0px 0px 5px",
                  padding: "5px"
                }}
              >
                Tv
              </a>
            </li>

            <li
              className="nav-item"
              style={{
                marginLeft: "2px",
                display:
                  eventDetails.game_type == 4 || eventDetails.game_type == 5
                    ? "none"
                    : ""
              }}
            >
              {" "}
              <a
                onClick={() => showScoreBoard()}
                className="nav-link scoreOpen active"
                data-toggle="tab"
                href="#tv-section-2"
                role="tab"
                style={{
                  borderRadius: "0px 5px 5px 0px !important",
                  padding: "5px"
                }}
              >
                Score Card
              </a>{" "}
            </li>
          </ul>

          <div className="tab-content">
            <div
              className={tvStatus ? "tab-pane active" : "tab-pane"}
              role="tabpanel"
            >
              <div
                className="tv-section-wrapper"
                style={{
                  height: "300px",
                  background: "#000",
                  borderRadius: "0px 0px 0px 0px"
                }}
              >
                {eventDetails.game_type}

                <iframe
                  width="100%"
                  src={getIframeUrl(
                    eventDetails.game_type,
                    eventDetails.evt_id
                  )}
                  height="300"
                  title="Online Sport Live Score"
                  scrolling="auto"
                  marginWidth="0"
                  marginHeight="0"
                  frameBorder="0"
                  allowFullScreen="allowfullscreen"
                  className="live-score-iframe"
                  style={{ backgroundColor: "rgb(16, 16, 16)" }}
                  id="scoreFrame"
                  data-ruffle-polyfilled=""
                ></iframe>
              </div>
            </div>

            <div
              className={scoreStatus ? "tab-pane active" : "tab-pane"}
              role="tabpanel"
            >
              <div
                className="tv-section-wrapper"
                style={{ height: "180px", background: "#000" }}
              >
                Scoreboard
                {/*<iframe width="100%" src="https://lmt.vrnlscore.com/scores/index.html?scoreId=&amp;sportid=4" height="200" title="Online Sport Live Score" scrolling="auto" marginWidth="0" marginHeight="0" frameBorder="0" allowFullScreen="allowfullscreen" className="live-score-iframe" style={{ backgroundColor: "rgb(16, 16, 16)" }} id="scoreFrame" data-ruffle-polyfilled=""></iframe>*/}
              </div>
            </div>
          </div>
        </div>
        <div className="bets-section-wrapper" style={{ marginTop: "5px" }}>
          {/*bet slip code start here*/}
          <div>
            <div
              className="bets-wrapper"
              style={{
                display: betSlipDisplayStatus === true ? "" : "none",
                marginTop: "10px"
              }}
            >
              <div className="bets-wrapper-title">
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td> Bet Slip</td>
                      <td style={{ textAlign: "right" }}>
                        <Link
                          to="/profile"
                          target="_blank"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          Edit Bet Stakes
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                className="bets-wrapper-table"
                style={{ background: "transparent" }}
              >
                <table
                  className="table"
                  style={{
                    width: "100%",
                    margin: "0px",
                    background:
                      betObj.bet_type === "b" || betObj.bet_type === "B"
                        ? "var(--theme-bg-color)"
                        : "#fce3e4"
                  }}
                >
                  <thead>
                    <tr style={{ background: "#dddddd" }}>
                      <th style={{ width: "25%" }}>Bet for</th>
                      <th style={{ width: "20%" }}>Odds</th>
                      <th style={{ width: "25%" }}>Stake</th>
                      <th style={{ width: "30%" }}>Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ background: "transparent" }}>
                      <td style={{ width: "50%" }}>
                        <span style={{ fontWeight: "800" }}>
                          {betObj.runnername}
                        </span>
                      </td>
                      <td>
                        <input
                          type="number"
                          id="odd"
                          name="odd"
                          value={betObj.odds}
                          max="50"
                          step="0.01"
                          onChange={(e) => setOddValue(e.target.value)}
                          style={{
                            marginRight: "0px",
                            width: "100%",
                            height: "42px",
                            color: "black",
                            textAlign: "left",
                            border: "solid 1px gray",
                            padding: "5px 5px",
                            borderRadius: "4px",
                            fontSize: "17px",
                            display: betObj.market_type === "f" ? "none" : ""
                          }}
                        />

                        <span
                          style={{
                            fontWeight: "bold",
                            display: betObj.market_type === "f" ? "" : "none"
                          }}
                        >
                          {betObj.odds}
                        </span>
                      </td>
                      <td>
                        {" "}
                        <input
                          type="text"
                          className="form-control"
                          style={{
                            width: "75%",
                            marginLeft: "0px",
                            height: "42px",
                            borderRadius: "4px",
                            padding: "5px 5px",
                            fontSize: "17px",
                            color: "black",
                            border: "solid 1px gray"
                          }}
                          onChange={(e) => getTypeAmount(e.target.value)}
                          value={defaultAmount}
                        />
                      </td>
                      <td style={{ textAlign: "right", padding: "5px" }}>
                        <span
                          style={{
                            display: showProfitLossCalculation ? "" : "none"
                          }}
                        >
                          <span>{profit}</span> / - <span>{liability}</span>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="4" style={{ padding: "0px" }}>
                        <table style={{ width: "99%", border: "0px" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake1)}
                                >
                                  {stake1}
                                </span>
                              </td>
                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake2)}
                                >
                                  {stake2}
                                </span>
                              </td>
                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake3)}
                                >
                                  {stake3}
                                </span>
                              </td>
                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake4)}
                                >
                                  {stake4}
                                </span>
                              </td>
                            </tr>

                            <tr>
                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake5)}
                                >
                                  +{stake5}
                                </span>
                              </td>

                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake6)}
                                >
                                  +{stake6}
                                </span>
                              </td>

                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake7)}
                                >
                                  +{stake7}
                                </span>
                              </td>

                              <td style={{ padding: "1px", borderTop: "0px" }}>
                                <span
                                  className="points"
                                  onClick={() => setStake(stake8)}
                                >
                                  +{stake8}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  style={{
                    background:
                      betObj.bet_type === "b" || betObj.bet_type === "B"
                        ? "var(--theme-bg-color)"
                        : "#fce3e4"
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "20%" }}>
                          <input
                            type="button"
                            className="betsClose"
                            value="Close"
                            onClick={() => closeBetSlip()}
                            style={{
                              marginLeft: "4px",
                              border: "0px",
                              cursor: "pointer"
                            }}
                          />
                        </td>
                        <td style={{ width: "20%" }}>
                          <input
                            type="button"
                            className="betsClear"
                            value="Clear"
                            onClick={() => clearStake()}
                            style={{
                              marginLeft: "4px",
                              border: "0px",
                              cursor: "pointer"
                            }}
                          />
                        </td>
                        <td style={{ width: "60%", textAlign: "right" }}>
                          <div>
                            <button
                              type="button"
                              className="betsSubmit"
                              onClick={() => place_bet()}
                              style={{
                                marginRight: "4px",
                                border: "0px",
                                cursor: "pointer",
                                padding: "8px 19px",
                                display: betButtonShow ? "" : "none"
                              }}
                            >
                              <div>Submit</div>
                            </button>
                          </div>

                          <button
                            type="button"
                            className="betsSubmit"
                            style={{
                              marginRight: "4px",
                              border: "0px",
                              cursor: "pointer",
                              padding: "8px 19px",
                              display: betButtonShowLoaderShow ? "" : "none"
                            }}
                          >
                            <div>
                              Submit <div className="ld ld-ball ld-flip"></div>
                            </div>
                          </button>
                          <span style={{ color: "red" }}>
                            {betErrorMessage}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  style={{
                    display: "none",
                    padding: "5px",
                    textAlign: "right"
                  }}
                ></div>
              </div>
            </div>
          </div>

          <div className="bets-wrapper" style={{ marginTop: "5px" }}>
            <div aria-expanded="true" style={{ marginTop: "0px" }}>
              <div
                className="v-expansion-panel-content black--text pa-0"
                dark=""
              >
                <div className="v-expansion-panel-content__wrap">
                  <div className="">
                    <div>
                      <div>
                        <div
                          className="pa-5 text-center"
                          style={{ background: "#e7f5fc" }}
                        >
                          <div>
                            <table
                              style={{ display: "inline-table" }}
                              className="table-responsive table01 table01_matched"
                            >
                              <tbody style={{ backgroundColor: "#fff" }}>
                                <tr>
                                  <td
                                    colSpan="3"
                                    style={{
                                      background: "var(--theme-color)",
                                      padding: "0px 10px",
                                      lineHeight: "30px",
                                      color: "#fff",
                                      textAlign: "left",
                                      fontWeight: "bold"
                                    }}
                                  >
                                    Open Bets
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    lineHeight: "23px",
                                    backgroundColor: "#dddddd",
                                    color: "#2b2f35",
                                    fontWeight: "600"
                                  }}
                                >
                                  <th
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "10px",
                                      fontWeight: "600"
                                    }}
                                  >
                                    Runner
                                  </th>
                                  <th
                                    className="align-left"
                                    style={{ fontWeight: "600" }}
                                  >
                                    Price
                                  </th>
                                  <th
                                    className="align-right"
                                    style={{ fontWeight: "600" }}
                                  >
                                    Size
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div style={{ width: "100%", display: "" }}>
                            <table
                              style={{ display: "inline-table" }}
                              className="table-responsive table01 table01_matched"
                            >
                              <tbody style={{ backgroundColor: "#fff" }}>
                                <tr>
                                  <td
                                    colSpan="3"
                                    style={{
                                      background: "var(--theme-color)",
                                      padding: "0px 10px",
                                      lineHeight: "30px",
                                      color: "#fff",
                                      textAlign: "left",
                                      fontWeight: "bold"
                                    }}
                                  >
                                    Matched Bets ({betListArray.length})
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    lineHeight: "23px",
                                    backgroundColor: "#dddddd",
                                    color: "#2b2f35",
                                    fontWeight: "600"
                                  }}
                                >
                                  <th
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "10px",
                                      fontWeight: "600",
                                      width: "40%"
                                    }}
                                  >
                                    Runner
                                  </th>

                                  <th
                                    style={{ fontWeight: "600", width: "40%" }}
                                    className="align-left"
                                  >
                                    Price
                                  </th>

                                  <th
                                    style={{
                                      fontWeight: "600",
                                      width: "15%",
                                      textAlign: "right"
                                    }}
                                  >
                                    Size
                                  </th>
                                </tr>
                                {betListArray &&
                                  betListArray !== null &&
                                  betListArray !== undefined &&
                                  betListArray !== "" &&
                                  betListArray.map((bet) => (
                                    <tr
                                      style={{
                                        lineHeight: "23px",

                                        backgroundColor:
                                          bet.type?.toLowerCase() === "b" ||
                                          bet.type?.toLowerCase() === "y"
                                            ? "#e8f6fc"
                                            : "#fce3e4",
                                        color: "#2b2f35",
                                        lineHeight: "35px"
                                      }}
                                    >
                                      <td
                                        style={{
                                          verticalAlign: "top",
                                          borderTop: "1px solid #dee2e6",
                                          color: "#212529",
                                          textAlign: "left",
                                          padding: "4px",
                                          width: "40%"
                                        }}
                                      >
                                        {bet.section}
                                        {bet.bet_game_type == 1 &&
                                        bet.bet_market_type == 2
                                          ? "(BM)"
                                          : ""}
                                        {bet.bet_game_type == 1 &&
                                        bet.bet_market_type == 5
                                          ? "(TIE)"
                                          : ""}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "top",
                                          borderTop: "1px solid #dee2e6",
                                          color: "#212529",
                                          width: "40%"
                                        }}
                                      >
                                        {displayPrice(bet.rate, bet.bet_type)}
                                        {/*{Number(bet.rate).toFixed(2)}*/}
                                      </td>

                                      <td
                                        style={{
                                          verticalAlign: "top",
                                          borderTop: "1px solid #dee2e6",
                                          color: "#212529",
                                          paddingRight: "10px",
                                          width: "15%",
                                          textAlign: "right"
                                        }}
                                      >
                                        {formatTruncate(Math.round(bet.amnt))}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>

                          {/*         
                        <div style={{ width: "100%", display: "" }}>
                          <table
                            style={{ display: "inline-table" }}
                            className="table-responsive table01 table01_matched"
                          >
                            <tbody style={{ backgroundColor: "#fff" }}>
                              <tr>
                                <td
                                  colSpan="4"
                                  style={{
                                    background: "var(--theme-color)",
                                    padding: "0px 10px",
                                    lineHeight: "30px",
                                    color: "#fff",
                                    textAlign: "left",
                                    fontWeight: "bold"
                                  }}
                                >
                                  UnMatched Bets ({unmatchedBetListArray.length}
                                  )
                                </td>
                              </tr>
                              <tr
                                style={{
                                  lineHeight: "23px",
                                  backgroundColor: "#dddddd",
                                  color: "#2b2f35",
                                  fontWeight: "600"
                                }}
                              >
                                <th
                                  style={{
                                    textAlign: "left",
                                    paddingLeft: "10px",
                                    fontWeight: "600",
                                    width: "35%"
                                  }}
                                >
                                  Runner
                                </th>
                                <th
                                  style={{ fontWeight: "600", width: "30%" }}
                                  className="align-left"
                                >
                                  Price
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    width: "20%",
                                    textAlign: "right"
                                  }}
                                >
                                  Size
                                </th>
                                <th
                                  style={{
                                    fontWeight: "600",
                                    width: "15%",
                                    textAlign: "center"
                                  }}
                                ></th>
                              </tr>
                              {unmatchedBetListArray &&
                                unmatchedBetListArray.length > 0 &&
                                unmatchedBetListArray.map((bet, index) => (
                                  <tr
                                    key={bet._id || index}
                                    style={{
                                      lineHeight: "35px",
                                      backgroundColor:
                                        bet.type?.toLowerCase() === "b" ||
                                        bet.type?.toLowerCase() === "y"
                                          ? "#e8f6fc"
                                          : "#fce3e4",
                                      color: "#2b2f35"
                                    }}
                                  >
                                    <td
                                      style={{
                                        verticalAlign: "top",
                                        borderTop: "1px solid #dee2e6",
                                        color: "#212529",
                                        textAlign: "left",
                                        padding: "4px",
                                        width: "35%"
                                      }}
                                    >
                                      {bet.section}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "top",
                                        borderTop: "1px solid #dee2e6",
                                        color: "#212529",
                                        width: "30%"
                                      }}
                                    >
                                      {Number(bet.rate).toFixed(2)}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "top",
                                        borderTop: "1px solid #dee2e6",
                                        color: "#212529",
                                        paddingRight: "10px",
                                        width: "20%",
                                        textAlign: "right"
                                      }}
                                    >
                                      {formatTruncate(Math.round(bet.amnt))}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        borderTop: "1px solid #dee2e6",
                                        width: "15%",
                                        textAlign: "center",
                                        padding: "4px"
                                      }}
                                    >
                                      <button
                                        type="button"
                                        disabled={
                                          !!deletingUnmatchedIds[bet._id]
                                        }
                                        onClick={() =>
                                          deleteUnmatchedBet(bet._id)
                                        }
                                        title="Delete unmatched bet"
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          color: "#c0392b",
                                          fontWeight: "bold",
                                          fontSize: "16px",
                                          cursor: deletingUnmatchedIds[bet._id]
                                            ? "wait"
                                            : "pointer",
                                          lineHeight: 1,
                                          padding: "0 6px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          minWidth: "18px",
                                          minHeight: "18px"
                                        }}
                                      >
                                        {deletingUnmatchedIds[bet._id] ? (
                                          <span
                                            style={{
                                              width: "12px",
                                              height: "12px",
                                              border: "2px solid #ccc",
                                              borderTopColor: "#c0392b",
                                              borderRadius: "50%",
                                              display: "inline-block",
                                              animation:
                                                "unmatchedDeleteSpin 0.7s linear infinite"
                                            }}
                                          />
                                        ) : (
                                          "×"
                                        )}
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                              */}

                          <table
                            width="100%"
                            className="table-responsive table01"
                            style={{ display: "inline-table" }}
                          ></table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="desktop_view"></div>

          <div className="bets-wrapper" style={{ marginTop: "-22px" }}>
            <div className="bets-wrapper-title">Related Events</div>
            <div className="related-events-wrapper-table">
              <table>
                <tbody>
                  {relatedEvents &&
                    relatedEvents !== null &&
                    relatedEvents !== undefined &&
                    relatedEvents !== "" &&
                    relatedEvents.map((data) => (
                      <tr>
                        <td className="sport-date">
                          <div style={{ whiteSpace: "nowrap" }}>
                            <span className="market-time dateLocalTimeRace">
                              <span className="dateLocalTimeRaceText">
                                {DateCheck(data?.evt_od)}
                                <br></br>
                                {moment
                                  .utc(data?.cat_mstart)
                                  .local()
                                  .format("hh:mm a")}
                              </span>
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <a
                              href={`/market/${data.cat_mid}`}
                              style={{ color: "black" }}
                            >
                              {showEventName(data)}
                            </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
};
export default RightSide;